<template>
  <div v-if="!isLoading">
    <vs-row class="mb-5">
      <div class="flex justify-end w-full">
        <router-link target="_blank" :to="`/eventoPDF/${formData.idEvento}`">
          <vs-button
            v-tooltip="'Relatório Eventos PDF'"
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-file-text"
            class="mr-3 mb-2 btn-print"
          >
          </vs-button>
        </router-link>
        <a
          v-if="formData.dadosGerais.linkCertificadoAberturaEvento"
          target="_blank"
          :href="`${formData.dadosGerais.linkCertificadoAberturaEvento}`"
        >
          <vs-button
            v-tooltip="'Aviso Sinistro Digital'"
            color="warning"
            type="gradient"
            icon-pack="feather"
            icon="icon-file-text"
            class="mr-3 mb-2 btn-print"
          >
            Aviso Sinistro Digital
          </vs-button>
        </a>
        <router-link :to="`/editar-evento/${formData.idEvento}`">
          <vs-button
            type="flat"
            v-if="$can($actionsDefault.Leitura, 'Eventos')"
          >
            Ir para Edição
          </vs-button>
        </router-link>
      </div>
    </vs-row>

    <!-- Card's -->
    <vs-row class="mt-5">
      <EventosCard :dadosEvento="formData" />
      <AssociadoCard :dadosEvento="formData" />
      <VeiculoCard :dadosEvento="formData" />
    </vs-row>

    <div v-if="1 == 2">
      {{ formData }}
    </div>

    <vs-row class="mt-5">
      <vx-card>
        <EventosAnaliseForm :formData="formData" :dominios="dominios" />

        <TerceirosList
          :idEvento="formData.idEvento"
          :terceiros="formData.terceiros"
          :modeAnalise="true"
        />

        <DadosEventosForm :formData="formData" />

        <LocalEventoForm :formData="formData" />

        <OutrosEventos
          v-if="formData.dadosCliente"
          :listOutrosEventos="listOutrosEventos"
          :listQtdTiposEventos="listQtdTiposEventos"
          :totalQtdEventos="totalQtdEventos"
          @buscaTodosOutrosEventos="buscaEventosPorBeneficiario(idBeneficiario)"
        />

        <AnaliseBoletosList :listBoletos="formData.listBoletos" />

        <ProdutosList :listProdutos="formData.listProdutos" />

        <CardEventoVeiculos :listVeiculos="listVeiculos" />

        <ArquivosVistoriaList :listArquivosVistoria="listArquivosVistoria" />

        <BoletimOcorrencia :formData="formData" :dominios="dominios" />

        <FotosDocumentos
          :formData="formData"
          :arquivos="formData.listFotosDocumentos"
          :idReferente="idReferenteEvento"
          :title="`Fotos do Veículo do Beneficiário`"
        />

        <div
          v-for="(element, index) in formData.listFotosDocumentosTerceiros"
          :key="index"
        >
          <FotosDocumentos
            :formData="element"
            :arquivos="element.listFotosDocumentos"
            :idReferente="idReferenteTerceiro"
            :title="`Fotos do Veículo Terceiro: ${element.nome || ''}`"
          />
        </div>

        <LocalEventoView :formData="formData" />

        <AnaliseTecnicaForm
          :historicoResumoAnalista="historicoResumoAnalista"
          :formData="formData"
          :dominios="dominios"
        />
      </vx-card>
    </vs-row>

    <!-- Botão Salvar -->
    <vs-row class="mt-5">
      <div class="flex justify-between w-full">
        <div class="mb-2 flex gap-3">
          <vs-button
            color="primary"
            type="filled"
            v-if="$can('Histórico de Alterações', 'Eventos')"
            @click="abrirModalHistoricoEventos(formData.idEvento)"
            ><vs-icon icon-pack="feather" icon="icon-list"></vs-icon>
            Histórico Alterações
          </vs-button>
        </div>
        <div>
          <BotaoSubmit
            v-if="$can($actionsDefault.Escrita, 'Análise de Eventos')"
            text="Salvar Alterações"
            :variant="'success'"
            :edit="!loadingButton"
            :aguarde="loadingButton"
            class="ml-4"
            @submit="submit()"
          ></BotaoSubmit>
        </div>
      </div>
    </vs-row>
    <div>
      <ModalHistoricoEventos
        :popupActive="modalHistoricoEvento"
        :dadosConsulta="dadosConsultaHistorico"
        @close="closeModais"
      ></ModalHistoricoEventos>
    </div>
  </div>
</template>

<script>
import service from './../../../../services';
import notify from './../../../../utils/notify';
import axios from 'axios';
import serviceEventos from './../shared/service';
import {
  FOTO_REFERENTE_EVENTO,
  FOTO_REFERENTE_TERCEIROS,
} from './../shared/const';

// Component
import AssociadoCard from '../shared/components/card/AssociadoCard.vue';
import EventosCard from '../shared/components/card/EventoCard.vue';
import VeiculoCard from '../shared/components/card/VeiculoCard.vue';

import AnaliseBoletosList from './components/AnaliseBoletosList.vue';
import AnaliseTecnicaForm from './components/AnaliseTecnicaForm.vue';
import BoletimOcorrencia from './components/BoletimOcorrenciaForm.vue';
import DadosEventosForm from './components/DadosEventosForm.vue';
import EventosAnaliseForm from './components/EventosAnaliseForm.vue';
import FotosDocumentos from './../shared/components/FotosDocumentos.vue';
import LocalEventoForm from './../shared/components/LocalEventoForm.vue';
import LocalEventoView from './components/LocalEventoView.vue';
import ProdutosList from './components/ProdutosList.vue';
import ArquivosVistoriaList from './components/ArquivosVistoriaList.vue';
import TerceirosList from './../shared/components/TerceirosList.vue';
import BotaoSubmit from './../../../../components/BotaoSubmit.vue';
import ModalHistoricoEventos from '../../../modais/ModalHistoricoEventos.vue';
import jwt from 'jsonwebtoken';
import CardEventoVeiculos from '../../../pages/PainelComercial/components/CardEventoVeiculos.vue';
import OutrosEventos from './components/OutrosEventos.vue';

export default {
  components: {
    AssociadoCard,
    EventosCard,
    VeiculoCard,
    AnaliseBoletosList,
    AnaliseTecnicaForm,
    BoletimOcorrencia,
    DadosEventosForm,
    EventosAnaliseForm,
    FotosDocumentos,
    LocalEventoForm,
    LocalEventoView,
    ProdutosList,
    TerceirosList,
    BotaoSubmit,
    ModalHistoricoEventos,
    ArquivosVistoriaList,
    CardEventoVeiculos,
    OutrosEventos,
  },
  data() {
    return {
      isLoading: true,
      loadingButton: false,
      dominios: {
        listUsuarios: [],
        listMonta: [],
      },
      formData: {
        idEvento: null,
        protocolo: null,
        dadosCliente: {},
        dadosVeiculo: {},
        dadosGerais: {},
        dadosAnalise: {},
        condutor: {},
        terceiros: [],
        dadosEventos: {},
        enderecoEvento: {},
        novoLocalEvento: {},
        listLocaislEvento: [],
        boletimOcorrencia: {},
        listFotosDocumentos: [],
        listFotosCroqui: [],
        listFotosDocumentosTerceiros: null,
        analiseTecnica: {},
        listBoletos: [],
        listProdutos: [],
      },
      listArquivosVistoria: [],
      idReferenteEvento: FOTO_REFERENTE_EVENTO,
      idReferenteTerceiro: FOTO_REFERENTE_TERCEIROS,
      dadosConsultaHistorico: {},
      modalHistoricoEvento: false,
      historicoResumoAnalista: [],
      nomeUsuario: null,
      situacao: null,
      corSituacao: null,
      corSituacoes: {},
      listVeiculos: [],
      idBeneficiario: 0,
      listOutrosEventos: [],
      listQtdTiposEventos: [],
      totalQtdEventos: 0,
    };
  },
  methods: {
    async getDominis() {
      try {
        this.$vs.loading();

        const promises = [
          serviceEventos.getListUsuarios(),
          serviceEventos.getListDominio('domEventosMonta', 'monta', 'idMonta'),
        ];

        const [listUsuarios, listMonta] = await Promise.all(promises);

        this.dominios.listUsuarios = listUsuarios;
        this.dominios.listMonta = listMonta;
      } catch (error) {
        console.error(error);
        notify.notifyFail(this.$vs, 'Falha ao carregar os dados do evento');
      } finally {
        this.$vs.loading.close();
      }
    },
    async getEvento() {
      const { idEvento } = this.$route.params;

      if (!idEvento) {
        return;
      }

      try {
        this.$vs.loading();

        const result = await service.getAll(
          'eventos2',
          null,
          `analise/${idEvento}`,
        );
        const evento = result.data;

        if (!evento) {
          notify.notifyFail(
            this.$vs,
            'Você não tem acesso à visualização deste Evento',
          );
          this.$vs.loading.close();
          return;
        }

        this.isLoading = false;

        this.$nextTick(() => {
          this.formData = evento;
        });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async getHistoricosResumoAnalista() {
      const { idEvento } = this.$route.params;
      if (!idEvento) {
        return;
      }
      try {
        this.$vs.loading();

        const historico = await service.getAll(
          'historico-resumos-analistas',
          null,
          `buscarHisoticosResumoAnalista/${idEvento}`,
        );
        this.historicoResumoAnalista = historico.data;

        if (!this.historicoResumoAnalista) {
          this.$vs.loading.close();
          return;
        }

        this.historicoResumoAnalista.forEach((item) => {
          const createdAtDate = new Date(item.createdAt);
          item.createdAtDate = createdAtDate.toLocaleDateString();
          item.createdAtTime = createdAtDate.toLocaleTimeString();
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async getSituacao() {
      const { idEvento } = this.$route.params;
      if (!idEvento) {
        return;
      }

      const status = {
        PRE_CADASTRO: 1,
        EM_ANALISE: 2,
        EM_REGULAGEM: 3,
        AGUARDANDO_ASSOCIADO: 4,
        DESISTENCIA: 5,
        FINALIZADO: 6,
      };

      const dadosGerais = await service.getAll('eventos2', null, idEvento);
      const { idStatus } = dadosGerais.data.dadosGerais;

      switch (idStatus) {
        case status.PRE_CADASTRO:
          this.situacao = 'Pré Cadastro';
          this.corSituacao = this.corSituacoes[0].corStatus;
          break;
        case status.EM_ANALISE:
          this.situacao = 'Em análise';
          this.corSituacao = this.corSituacoes[1].corStatus;
          break;
        case status.EM_REGULAGEM:
          this.situacao = 'Em Regulagem';
          this.corSituacao = this.corSituacoes[2].corStatus;
          break;
        case status.AGUARDANDO_ASSOCIADO:
          this.situacao = 'Aguardando Associado';
          this.corSituacao = this.corSituacoes[3].corStatus;
          break;
        case status.DESISTENCIA:
          this.situacao = 'Desistencia';
          this.corSituacao = this.corSituacoes[4].corStatus;
          break;
        case status.FINALIZADO:
          this.situacao = 'Finalizado';
          this.corSituacao = this.corSituacoes[5].corStatus;
          break;
        default:
          this.situacao = '';
      }
    },

    async getCorSituacao() {
      const body = {};
      const situacoesEvento = await service.post(
        'Eventos',
        'buscar-situacoes-evento',
        body,
      );
      this.corSituacoes = situacoesEvento.data;
    },

    async getArquivosVistoria() {
      try {
        const { id_proposta } = this.formData.dadosVeiculo;

        const bodyObject = {
          idProposta: id_proposta,
        };

        const arquivosVistoriaServiceResult = await service.post(
          'Cotacao',
          'listarFotosCotacao',
          bodyObject,
        );
        const arquivosVistoriaArray = arquivosVistoriaServiceResult.data;
        this.listArquivosVistoria = [];

        const coordenatesArray = [];

        arquivosVistoriaArray.forEach((file) => {
          file.endereco = file.latitude
            ? 'Carregando endereço...'
            : 'Não identificado';

          if (file.latitude) {
            const locationPromise = this.reverseCoordenates(file);
            coordenatesArray.push(locationPromise);
          }

          this.listArquivosVistoria.push(file);
        });

        const coordenatesResults = await Promise.allSettled(coordenatesArray);

        coordenatesResults.forEach((result) => {
          const isFileFullfiled = result.status === 'fulfilled';

          const elementId = isFileFullfiled
            ? result.value.element.id_PropostaFoto
            : result.reason.element.id_PropostaFoto;
          const file = this.listArquivosVistoria.find(
            (file) => file.id_PropostaFoto === elementId,
          );

          if (isFileFullfiled) {
            file.endereco = result.value.res.data.address;
            return;
          }

          file.endereco = 'Não foi Possível Reverter Latitude';
        });
      } catch (error) {
        console.error(error);
      }
    },
    async reverseCoordenates(element) {
      try {
        const endpoint = `https://nominatim.openstreetmap.org/reverse?&format=json&lat=${element.latitude}&lon=${element.longitude}&zoom=21&addressdetails=1`;
        const response = await axios.get(endpoint);
        return { element, response };
      } catch (error) {
        throw { element, error };
      }
    },
    async submit() {
      try {
        this.$vs.loading();

        const data = { ...this.formData };

        const dataEvento = await service.post(
          'eventos2',
          'analise/update-evento',
          data,
        );
        if (this.formData.analiseTecnica.resumoAnalista) {
          const baseDecimal = 10;
          await service.post(
            'historico-resumos-analistas',
            'criarResumoAnalista',
            {
              idEvento: parseInt(this.formData.idEvento, baseDecimal),
              usuario: this.nomeUsuario,
              resumoDoAnalista: this.formData.analiseTecnica.resumoAnalista,
              situacao: this.situacao,
              corSituacao: this.corSituacao,
            },
          );
          await this.getHistoricosResumoAnalista();
        }
        this.formData = dataEvento.data;
        notify.notifySuccess(this.$vs, 'Evento salvo com sucesso!');
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async buscaDadosToken() {
      const token = localStorage.getItem('user-token');
      if (token) {
        const decoded = jwt.decode(token);
        this.nomeUsuario = decoded.nome;
      }
    },
    abrirModalHistoricoEventos(idEvento) {
      this.dadosConsultaHistorico = idEvento;
      this.modalHistoricoEvento = true;
    },
    closeModais() {
      this.modalHistoricoEvento = false;
    },
    async buscaListVeiculos() {
      try {
        const { idProspect } = this.formData.dadosCliente;

        const dataEvento = await service.getAll(
          'eventos2',
          {},
          `get-veiculos-count/${idProspect}`,
        );
        this.listVeiculos = dataEvento.data;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },

    async buscaEventosPorBeneficiario(idBeneficiario, pagina) {
      try {
        this.$vs.loading();
        const resultEventosBeneficiario =
          await serviceEventos.getEventosPorBeneficiario(
            idBeneficiario,
            pagina,
          );

        this.listOutrosEventos = resultEventosBeneficiario.data.filter(
          (eventos) => eventos.idEvento !== this.formData.idEvento,
        );
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async buscaQtdTipoEventoPorBeneficiario(idBeneficiario) {
      try {
        const result = await serviceEventos.getQtdTiposEventosPorBeneficiario(
          idBeneficiario,
        );
        this.listQtdTiposEventos = result.data;

        this.totalQtdEventos = this.listQtdTiposEventos.find(
          (tipoEvento) => tipoEvento.nomeStatus === 'Total de Eventos',
        ).quantidadeEventos;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async mounted() {
    await this.getDominis();
    await this.getEvento();
    await this.getHistoricosResumoAnalista();
    await this.buscaDadosToken();
    await this.getCorSituacao();
    await this.getSituacao();
    await this.getArquivosVistoria();
    await this.buscaListVeiculos();
    this.idBeneficiario = this.formData.dadosCliente.idProspect;
    await this.buscaEventosPorBeneficiario(this.idBeneficiario, 1);
    await this.buscaQtdTipoEventoPorBeneficiario(this.idBeneficiario);
  },
};
</script>

<style lang="scss">
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>
